import clsx from "clsx";
import { Check2Icon, CheckIcon, CrossIcon } from "@/shared/icons";

type Props = {
  checked: boolean;
  className?: string;
  onChange: () => void;
  isDisabled?: boolean;
  variant?: "variant-1" | "variant-2" | "variant-3" | "variant-4";
};

export default function Checkbox({
  checked,
  className,
  onChange,
  isDisabled,
  variant = "variant-1",
}: Props) {
  return (
    <button
      type="button"
      className={clsx(
        "relative flex aspect-square w-5 shrink-0 items-center justify-center rounded-[0.25rem] transition-all hover:brightness-110",
        {
          "bg-gradient-accent": (variant === "variant-1" || variant === "variant-2") && checked,
          "bg-accent-muted/20 border border-accent-solid/40": variant === "variant-1" && !checked,
          "bg-dark-900": variant === "variant-2" && !checked,
          "border border-[#191919] rounded-md": variant === "variant-3",
          "border border-dark-800 bg-dark-800 rounded-md pointer-events-none":
            variant === "variant-3" && isDisabled,
          "bg-dark-800 rounded-md": variant === "variant-4" && !isDisabled,
          "border border-dark-800 rounded-md pointer-events-none":
            variant === "variant-4" && isDisabled,
        },
        className,
      )}
      onClick={onChange}
    >
      {variant === "variant-3" && !checked && (
        <CrossIcon
          className={clsx(
            "absolute size-3 text-accent-solid transition-all",
            !checked ? "opacity-100" : "opacity-0",
          )}
        />
      )}
      {variant !== "variant-4" && (
        <CheckIcon
          className={clsx(
            "size-3 transition-all",
            checked ? "opacity-100" : "opacity-0",
            variant === "variant-3" && "text-[#84FF97]",
          )}
        />
      )}
      {variant === "variant-4" && (
        <Check2Icon
          className={clsx("size-full transition-all", checked ? "opacity-100" : "opacity-0")}
        />
      )}
    </button>
  );
}
